import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import pl from './locales/pl.json';
import tr from './locales/tr.json';
import fr from './locales/fr.json';
import es from './locales/es.json';
import uk from './locales/uk.json';
import de from './locales/de.json';
import hu from './locales/hu.json';
import { DefaultLanguage } from './constants';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: DefaultLanguage,
    debug: import.meta.env.DEV,

    resources: {
      en: { translation: en },
      pl: { translation: pl },
      tr: { translation: tr },
      fr: { translation: fr },
      es: { translation: es },
      uk: { translation: uk },
      de: { translation: de },
      hu: { translation: hu },
    },

    interpolation: {
      escapeValue: false,
    },
  })
  .then();

export default i18n;
